
import { defineComponent } from "vue";
import { MdSidebar, IMenuItem, ISidebarFAB } from "@/components/md/MdSidebar";

export default defineComponent({
  name: "BotSidebar",
  components: {
    MdSidebar,
  },
  data() {
    const prefix = "/bot/" + this.$route.params.chatbotId;
    return {
      menu: [
        {
          icon: "dashboard",
          title: "Übersicht",
          href: prefix + "/dashboard",
        },
        {
          icon: "timeline",
          title: "Versionen",
          href: prefix + "/versions",
        },
        {
          icon: "inbox",
          title: "Posteingang",
          href: "/inbox/" + this.$route.params.chatbotId + "/all",
          disabled: true,
        },
        {
          headline: "Entwicklung",
        },
        {
          icon: "merge_type",
          title: "Bot Builder",
          href: prefix + "/flows",
        },
        {
          icon: "travel_explore",
          title: "Entitäten",
          href: prefix + "/entites",
          disabled: true,
        },
        {
          icon: "perm_media",
          title: "Mediathek",
          href: prefix + "/files",
          disabled: true,
        },
        {
          icon: "list",
          title: "Logs",
          href: prefix + "/logs",
          disabled: true,
        },
        {
          headline: "Optimierung",
        },
        {
          icon: "psychology",
          title: "Verständnis",
          href: prefix + "/understanding",
          disabled: true,
        },
        {
          icon: "model_training",
          title: "Training",
          href: prefix + "/training",
          disabled: true,
        },
        {
          icon: "multiline_chart",
          title: "Analyse",
          href: prefix + "/analysis",
          disabled: true,
        },
        {
          headline: "Support",
        },
        {
          icon: "question_answer",
          title: "FAQ",
          href: prefix + "/faqs",
          disabled: true,
        },
        {
          headline: "Marketing",
        },
        {
          icon: "supervisor_account",
          title: "Zielgruppen",
          href: prefix + "/audiences",
          disabled: true,
        },
        {
          icon: "send",
          title: "Broadcasts",
          href: prefix + "/broadcasts",
          disabled: true,
        },
        {
          divider: true,
        },
        {
          icon: "extension",
          title: "Kanäle",
          href: prefix + "/channels",
          disabled: true,
        },
        {
          icon: "wysiwyg",
          title: "WhatsApp Templates",
          href: prefix + "/templates",
          disabled: true,
        },
        {
          icon: "security",
          title: "Datenschutz-Center",
          href: prefix + "/privacy",
          disabled: true,
        },
        {
          icon: "settings",
          title: "Einstellungen",
          href: prefix + "/settings",
          disabled: true,
        },
      ] as IMenuItem[],
    };
  },
});
